import { getToken } from "../../../shared/utils/common";

export class CommandSetTemplateMedia {
  async run(templateId: number, file: File, metadata?: any) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ad_templates/${templateId}/media_file/`;

    const formData = new FormData();
    formData.append("media_file", file);
    formData.append("metadata", JSON.stringify(metadata || {}));

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Authorization": `Token ${getToken()}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
      }

      return await response.json();
    } catch (err) {
      console.error("Error uploading thumbnail:", err);
      throw err;
    }
  }
}
